// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__--K8B","buttons":"SendReceipts_buttons__YCjra","email":"SendReceipts_email__2w_Z8","bookApptTitle":"SendReceipts_bookApptTitle__2dDu4"};